// extracted by mini-css-extract-plugin
module.exports = {"modal":"CheckoutForm-module--modal--VW-z3"};